<template>
  <div class="col-xl-4 col-sm-6 col-xs-12" v-bind="$attrs" v-on="$listeners">
    <div class="nominee-card card-base">
      <div :title="getFullName(nominee)" class="emphasize">{{getFullName(nominee)}}</div>
      <div class="row margin-bottom">
        <div class="col-xs-11">
          <span class="margin-right-x3">{{nominee|showFinancialYears}}</span>
          <span class="margin-right-x3">{{nomineeTypeMap[nominee.nominee_type]}}</span>
          <span
            :class="status[nominee.nomineeStatus].toLowerCase()"
          >{{status[nominee.nomineeStatus]}}</span>
        </div>
      </div>
      <div class="row margin-bottom">
        <div class="col-xs-5">
          <img class="margin-right" :src="images.birth" alt />
          <span>{{nominee.dob|toDateString("YYYY MMM DD")}}</span>
        </div>
        <div class="col-xs-5">
          <img class="margin-right" :src="images.location" alt />
          <span v-show="nominee.nationality">{{countryMap[nominee.nationality]}}</span>
        </div>
      </div>
      <div class="row icon-row">
        <div class="col-xs-10">
          <img class="margin-right" :src="images.passport" alt />
          <span>{{nominee.passportNumber}}&nbsp;</span>
          <span v-if="nominee.expiryDate">(EXP {{nominee.expiryDate|toDateString("YYYY MMM DD")}})</span>
        </div>
        <div
          v-show="nominee.nomineeStatus===nomineeStatus.approved"
          class="col-xs-2 icon-area text-right"
        >
          <img @click="onEdit" :src="images.edit" :class="{'margin-right':removable}" alt />
          <img v-if="removable" @click="onDelete" :src="images.trash" alt />
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-xs-7">Confirmed Booking</div>
        <div
          class="col-xs-5 text-right b spacing-wide"
        >{{entitlement.confirmedUsed}}/{{entitlement.confirmed}}</div>
      </div>
      <div class="row">
        <div class="col-xs-7">Standby Booking</div>
        <div
          class="col-xs-5 text-right b spacing-wide"
        >{{entitlement.standbyUsed}}/{{entitlement.standby}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import images from "../../core/images";
import {
  nomineeStatus,
  nomineeTypeMap,
  nomineeStatusMap
} from "../../core/enum.js";
import { getFullName } from "../../core/staff-helper";
export default {
  inheritAttrs: false,
  name: "nominee-card",
  props: {
    nominee: {
      type: Object,
      required: true
    },
    countryMap: {
      type: Object
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onEdit() {
      this.$emit("clickEdit", this.nominee.uuid);
    },
    onDelete() {
      this.$emit("clickDelete", this.nominee.uuid);
    },
    getFullName(usr) {
      return getFullName(usr);
    }
  },
  filters: {
    showFinancialYears(n) {
      let start = new Date(n.startDate);
      let end = new Date(n.endDate);
      return `${start.getFullYear()}-${end.getFullYear()}`;
    }
  },
  computed: {
    images: () => images,
    status: () => nomineeStatusMap,
    nomineeStatus: () => nomineeStatus,
    nomineeTypeMap: () => nomineeTypeMap,
    entitlement() {
      return this.nominee.entitlement || {};
    }
  }
};
</script>
